/** Hàng đợi toast (hàm thuần). Toast thường tự tắt sau 4,5 giây; lỗi không tự tắt (Hybrid-Kit §3). */
export interface ToastItem {
  id: number;
  msg: string;
  tone: 'ok' | 'err';
  /** có thì hiện nút Hoàn tác */
  undo?: () => void;
}

export const TOAST_MS = 4500;
/** tối đa toast cùng lúc; cũ nhất bị đẩy ra */
export const TOAST_MAX = 3;

export function push(list: readonly ToastItem[], t: ToastItem): ToastItem[] {
  return [...list, t].slice(-TOAST_MAX);
}
export function drop(list: readonly ToastItem[], id: number): ToastItem[] {
  return list.filter((t) => t.id !== id);
}
export const autoClose = (t: ToastItem) => t.tone !== 'err';
